import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { format, endOfMonth, differenceInDays } from 'date-fns';
import { ja } from 'date-fns/locale';

export default function Header() {
  const today = new Date();
  const currentMonth = format(today, 'M', { locale: ja });
  const endOfCurrentMonth = endOfMonth(today);
  const daysLeft = differenceInDays(endOfCurrentMonth, today);

  return (
    <div className="bg-brand-card rounded-xl p-4 mb-4 border border-brand-main/30 shadow-[0_0_15px_rgba(0,169,95,0.1)]">
      <div className="flex justify-between items-center">
        <h1 className="text-xl md:text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-brand-main to-green-300 flex items-center gap-2">
          <span>🏆</span> {currentMonth}月のランキング
        </h1>
        <div className="text-right">
          <div className="text-xs text-gray-400 font-medium">残り期間</div>
          <div className="text-lg font-bold text-brand-accent">
            あと {daysLeft} 日
          </div>
        </div>
      </div>
      
      <div className="mt-3 bg-brand-dark/50 rounded-lg p-2 flex items-center gap-2 text-sm border border-brand-accent/20">
        <SafeIcon icon={FiIcons.FiGift} className="text-brand-accent text-lg flex-shrink-0" />
        <p className="text-gray-200 text-xs md:text-sm">
          上位<span className="text-brand-accent font-bold text-base mx-1">4</span>名は
          <span className="font-bold text-white mx-1">Amazonギフト券</span>対象！
        </p>
      </div>
    </div>
  );
}